import React, { createContext, useContext, useState, useEffect } from 'react';
import { THEMES, PALETTE } from '../themeConstants';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem('landing_theme');
        return savedTheme || THEMES.SYSTEM;
    });

    const [currentTheme, setCurrentTheme] = useState(THEMES.LIGHT);

    useEffect(() => {
        const handleSystemThemeChange = (e) => {
            if (theme === THEMES.SYSTEM) {
                setCurrentTheme(e.matches ? THEMES.DARK : THEMES.LIGHT);
            }
        };

        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

        // Initial set
        if (theme === THEMES.SYSTEM) {
            setCurrentTheme(mediaQuery.matches ? THEMES.DARK : THEMES.LIGHT);
        } else {
            setCurrentTheme(theme);
        }

        // Listen for changes
        mediaQuery.addEventListener('change', handleSystemThemeChange);

        return () => mediaQuery.removeEventListener('change', handleSystemThemeChange);
    }, [theme]);

    const toggleTheme = (newTheme) => {
        setTheme(newTheme);
        localStorage.setItem('landing_theme', newTheme);
    };

    const colors = PALETTE[currentTheme];

    return (
        <ThemeContext.Provider value={{ theme, currentTheme, toggleTheme, colors }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
